import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import { StyledContainer } from "components/StyledContainer";
import styled from "styled-components";

export const FixedContainer = styled.a`
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  background: ${({ theme }) => theme.colors.black};
  z-index: 9999;
  display: flex;
  justify-content: center;
`;

export const Wrapper = styled(StyledContainer)`
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  height: 88px;
  min-height: 88px;
  width: 100%;
  overflow: hidden;
`;

export const StyledMobileVideo = styled.video`
  height: 88px;
  min-height: 88px;
  width: 100%;
  width: 832px;
  z-index: 0;
`;

export const StyledVideo = styled.video`
  height: 88px;
  min-height: 88px;
  width: 100%;
  width: 1200px;
  z-index: 0;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  position: absolute;
  left: 50%;
  bottom: 12px;
  transform: translateX(-50%);
`;

export const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.neutral00};
  text-align: center;
  font-size: 10px;
  font-weight: 700;
  line-height: 12px;
`;

export const Disclaimer = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.text4};
  font-size: 8px;
  line-height: 12px;
`;

export const TransparentButton = styled.button`
  background: transparent;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 8px;
  padding: 8px;
  outline: none;
  box-shadow: none;
  border: none;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    right: 0;
  }

  svg {
    transition: all 0.2s ease-in-out;
  }

  &:hover {
    svg {
      color: ${({ theme }) => theme.colors.ublue06};
    }
  }
`;
